import {createActions} from 'client/framework';

const normalActions = ['SET_CLASSROOM_ID', 'SET_DUE_DATE_RANGE_ID'];

export default createActions(null, normalActions);
